import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import { team_css_class_map } from "../../../../utils/utils";

const styles = {
  badge: {
    backgroundColor: "#8863CC",
  },
};

const CustomBadgeSubstitute = withStyles(styles)(
  ({ classes, badgeContent, props }) => (
    <Badge
      badgeContent={badgeContent}
      variant={"dot"}
      classes={{ badge: classes.badge }}
    >
      <img
        className={`playerinformation-image ${
          team_css_class_map[props.player_information_props.Team]
        } align-items-center player_image`}
        src={props.player_information_props.ImageURL}
      ></img>
    </Badge>
  )
);

export default CustomBadgeSubstitute;
